import { render, staticRenderFns } from "./involved-dialog.vue?vue&type=template&id=c084912c&scoped=true&lang=pug&"
import script from "./involved-dialog.vue?vue&type=script&lang=js&"
export * from "./involved-dialog.vue?vue&type=script&lang=js&"
import style0 from "./involved-dialog.vue?vue&type=style&index=0&id=c084912c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c084912c",
  null
  
)

export default component.exports